var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-editor-container" },
    [
      _c(
        "el-row",
        { staticClass: "panel-group main", attrs: { gutter: 40 } },
        [
          _c(
            "el-col",
            { staticClass: "panel-group", attrs: { xs: 24, sm: 24, lg: 12 } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingUser,
                      expression: "loadingUser"
                    }
                  ],
                  staticClass: "card-panel left-height"
                },
                [
                  !_vm.loadingUser && !_vm.loadingProfile
                    ? _c(
                        "div",
                        { staticClass: "load-up left-panel-container" },
                        [
                          _c("div", { staticClass: "upper-section" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/images/logo.png"),
                                alt: "",
                                width: "150",
                                height: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "profile" }, [
                              _c("div", { staticClass: "greeting" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("dashboard.goodAfternoon")) +
                                    "，" +
                                    _vm._s(_vm.user.agentAccount) +
                                    "，" +
                                    _vm._s(_vm.$t("dashboard.welcome")) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "info",
                                  staticStyle: { display: "flex" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { width: "130px" } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t("dashboard.lastLoginTime")
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n                  ：" +
                                        _vm._s(_vm.user.lastLoginTime) +
                                        "\n                "
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c("div", { staticStyle: { width: "130px" } }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("dashboard.lastLoginIp")) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                  ：" +
                                      _vm._s(_vm.user.lastLoginIp) +
                                      "\n                "
                                  )
                                ])
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "lower-section" }, [
                            _c("div", { staticClass: "element" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "dashboard.agent.enterpriseRechargeTotal"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "value",
                                  staticStyle: { color: "#34bfa3" }
                                },
                                [
                                  _c("count-to", {
                                    staticClass: "card-panel-num",
                                    attrs: {
                                      "start-val": 0,
                                      "end-val": _vm.profile.organizationAmount,
                                      duration: 2600
                                    }
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("dashboard.agent.smsUnit")
                                      ) +
                                      "\n              "
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "element" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("dashboard.agent.numOfOrgs"))
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "value",
                                  staticStyle: { color: "#36a3f7" }
                                },
                                [
                                  _c("count-to", {
                                    staticClass: "card-panel-num",
                                    attrs: {
                                      "start-val": 0,
                                      "end-val":
                                        _vm.profile
                                          .organizationNumberActiveInLastTenDay,
                                      duration: 2600
                                    }
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("dashboard.agent.orgUnit")
                                      ) +
                                      "\n              "
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, lg: 12 } },
            _vm._l(_vm.cardInfo, function(pair, i) {
              return _c("CardInfo", {
                key: i,
                attrs: { pair: pair, loadingProfile: _vm.loadingProfile }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            background: "#fff",
            padding: "16px 16px 0",
            "margin-bottom": "32px"
          }
        },
        [
          _c("div", { staticClass: "graph-title" }, [
            _vm._v(_vm._s(_vm.$t("dashboard.agent.top5Orgs")))
          ]),
          _vm._v(" "),
          _vm.values.length
            ? _c("bar-chart", {
                ref: "barChart",
                attrs: {
                  labels: _vm.labels,
                  values: _vm.values,
                  placeholder: _vm.$t("dashboard.agent.SmsSent")
                }
              })
            : _c("div", { staticClass: "no-data" }, [
                _vm._v(_vm._s(_vm.$t("common.noData")))
              ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }